import {ChangeDetectorRef, Component, Input, OnDestroy} from '@angular/core';
import {Subscription} from 'rxjs/Subscription';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/delay';
import {ThingRainDiverterInterface} from '@app/app/shared/interfaces/thing/thing-rain-diverter.interface';
import {CommandsService} from '@app/app/shared/services/commands.service';

@Component({
  templateUrl: './park-rain-diverter-item.html',
  selector: 'park-rain-diverter-item'
})

export class ParkRainDiverterItemComponent implements OnDestroy {
  @Input() public rainDiverter: ThingRainDiverterInterface;
  @Input() public rainDiverterId: any;
  @Input() public parkId: any;
  @Input() public id: any;

  public isRunningAuto = false;
  public isRunningTank = false;
  public isRunningDrain = false;

  private timerSub: Subscription;

  private MODE_AUTO = 'auto';
  private MODE_TANK = 'tank';
  private MODE_DRAIN = 'drain';

  constructor(private comm: CommandsService, private cdRef: ChangeDetectorRef) {
    //
  }

  /**
   * Set mode to auto
   */
  public setModeAuto() {
    // Do not send command if another one is running
    if (!this.isRunning()) {
      this.isRunningAuto = true;
      this.update(this.MODE_AUTO);
    }
  }

  /**
   * Set mode to manual
   */
  public setModeTank() {
    // Do not send command if another one is running
    if (!this.isRunning()) {
      this.isRunningTank = true;
      this.update(this.MODE_TANK);
    }
  }

  /**
   * Set mode to off
   */
  public setModeDrain() {
    // Do not send command if another one is running
    if (!this.isRunning()) {
      this.isRunningDrain = true;
      this.update(this.MODE_DRAIN);
    }
  }

  public isAuto() {
    const isAuto = (this.rainDiverter.md === this.MODE_AUTO);

    if (isAuto && this.isRunningAuto) {
      this.isRunningAuto = false;
      this.cdRef.detectChanges();
    }

    return isAuto;
  }

  public isTank() {
    const isTank = (this.rainDiverter.md === this.MODE_TANK);

    if (isTank && this.isRunningTank) {
      this.isRunningTank = false;
      this.cdRef.detectChanges();
    }

    return isTank;
  }

  public isDrain() {
    const isDrain = (this.rainDiverter.md === this.MODE_DRAIN);

    if (isDrain && this.isRunningDrain) {
      this.isRunningDrain = false;
      this.cdRef.detectChanges();
    }

    return isDrain;
  }

  public isRunning() {
    return (this.isRunningAuto || this.isRunningTank || this.isRunningDrain);
  }

  /**
   * Update activator
   */
  private update(mode: string) {
    if (this.timerSub) {
      this.timerSub.unsubscribe();
    }

    this.comm.setRainDiverterMode(this.parkId, this.id, this.rainDiverterId, mode).then((res) => {
      this.timerSub = Observable.of(true).delay(15000).subscribe(() => {
        if (this.isRunningAuto && !this.isAuto()) {
          alert('Timed Out');
        }

        if (this.isRunningTank && !this.isTank()) {
          alert('Timed Out');
        }

        if (this.isRunningDrain && !this.isDrain()) {
          alert('Timed Out');
        }

        this.isRunningAuto = false;
        this.isRunningTank = false;
        this.isRunningDrain = false;
      });
    }).catch((err) => {
      this.isRunningAuto = false;
      this.isRunningTank = false;
      this.isRunningDrain = false;

      alert(err);
    });
  }

  ngOnDestroy() {
    if (this.timerSub) {
      this.timerSub.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/parks/park/controls/others/rain_diverter/rain-diverter-item/park-rain-diverter-item.component.ts